/**
 * Блок 2 · Ф8 «Права доступа» · В-О1а — изменяемые права и СТУПЕНЬ 1 резолвера.
 *
 * Основание — `DECISIONS.md`, по текущему тексту:
 *   · Р-202, «Итог круга: изменяемых прав — восемь…» — состав;
 *   · Р-191, «Права выдаются только руководителям отделов и администраторам…»;
 *   · Р-195, «„Вести“ работает только вместе с „видеть“…»;
 *   · Р-197, «„Запрет сильнее всего“ — теперь решение…; запрет наследуется
 *     помощниками ГИПа»;
 *   · Р-204, «Право, добавленное руководителю отдела, действует там, где он
 *     вошёл в объект…» — отсюда право НЕ булево;
 *   · Р-217 (б) — «вести договоры» руководителю отдела не выдаётся (⚠️ решение
 *     оркестратора, не владельца).
 *
 * ─── ⚠️ РЕШЕНИЕ ВЛАДЕЛЬЦА 11.10.2026 (Ф8 · В-У): ЗАПРЕТОВ БОЛЬШЕ НЕТ ─────────
 *
 * «Изначальные настройки отнимать не будем ни у кого. Только новые можно
 * отнимать». Положенное по ДОЛЖНОСТИ не отнимается ни у кого; супервайзер может
 * только ДОБАВИТЬ руководителю отдела право сверх должности и СНЯТЬ добавленное.
 *
 * Как это сделано — и чего НЕ сделано (⚠️ решение оркестратора о способе):
 *
 *   · ЗАКРЫТ ВХОД. `isEffectApplicable(DENY, …)` отвечает «нет» всегда: сервер
 *     по нему отказывает в записи (422), экран по нему не предлагает действие;
 *   · МЕХАНИЗМ НЕ ВЫРЕЗАН. Всё, что ниже написано про `DENY` и `'DENIED'` —
 *     ступень 1, наследование запрета помощниками ГИПа, ветка `denied` у
 *     `matchRightState`, — работает как работало. Строка `DENY`, оказавшаяся в
 *     базе (записана до решения либо мимо сервиса), ДЕЙСТВУЕТ, показывается в
 *     карточке и снимается сбросом (`INHERIT`). Штатным путём она не появится;
 *   · поэтому слова «отнято», «запрет», Р-197 в этом файле описывают МЕХАНИЗМ,
 *     а не то, что супервайзер может сделать. Вырезание механизма — отдельная
 *     работа, записана долгом.
 *
 * ⚠️ Два правила с похожими именами, и путать их нельзя: `isEffectApplicable` —
 * «можно ли ПОСТАВИТЬ эффект» (вход), `effectActsOnLevel` — «действует ли уже
 * ЛЕЖАЩАЯ строка на человека этого уровня» (механизм). Спросить про лежащую
 * строку правило входа — значит показать действующий запрет как «не действует».
 *
 * ─── Что здесь есть и чего нет ──────────────────────────────────────────────
 *
 * Ступень 1 отвечает на вопрос «ОТКУДА у человека право», а не «можно ли»:
 *
 *   'DENIED'  — отнято: нельзя нигде, и на своём объекте тоже (Р-197).
 *               ⚠️ С 11.10.2026 достижимо только через лежащую строку `DENY`;
 *   'GRANTED' — добавлено сверх должности: дальше решает предикат МЕСТА
 *               (ступень 2 — «вошёл ли в объект», своя у каждого права);
 *   'ROLE'    — поправок нет либо они инертны: решает действующее правило
 *               должности, без изменения.
 *
 * Ступени 2 здесь НЕТ, и булева «можно/нельзя» эта функция не возвращает
 * намеренно: одно и то же 'GRANTED' значит «да» для загруженности и «да, если
 * вошёл в объект» для расходов. Свернуть ответ в boolean на этом уровне —
 * значит решить за место.
 *
 * ─── ⚠️ ДОГОВОР ЧТЕНИЯ СОСТОЯНИЯ — для волн В-О2 и далее ────────────────────
 *
 * Три ошибки, каждая из которых компилируется и выглядит разумно:
 *
 *   1. `'ROLE'` — НЕ «можно» и НЕ «нельзя». Это «спроси действующее правило
 *      должности», а оно у уровней РАЗНОЕ: у администратора по всем восьми
 *      правам отвечает «да», у руководителя отдела — «нет» либо «в своём
 *      отделе», у сотрудника — «нет». Читать `ROLE` как ответ нельзя;
 *   2. `state !== 'DENIED'` — НЕ «разрешено». Так `ROLE` руководителя («нет по
 *      должности») превращается в «да». И обратное: `state === 'GRANTED'` — не
 *      «единственное да»: администратор получает своё через `ROLE`;
 *   3. `'GRANTED'` у ОБЪЕКТНОГО права (№ 3, № 5, № 6) — НЕ «да». Это «да
 *      там, где актор вошёл в объект» (Р-204); без ступени 2 ответа нет.
 *
 * Чтобы это не держалось на памяти читателя, состояние разбирается через
 * `matchRightState` — там обязательны ВСЕ три ветки, а ветка `granted` получает
 * признак «нужен предикат места». ⚠️ Запретить сравнение строк тип не может:
 * `state === 'DENIED'` по-прежнему компилируется. Свёртка делает неверное
 * неудобным, а не невозможным, — потребителя проверяет ревью его волны.
 *
 * ─── Сборка входа — тоже здесь ──────────────────────────────────────────────
 *
 * `collectActorRights` собирает вход ступени 1 из СТРОК таблицы и отбрасывает
 * строки, инертные по должности (снимок `roleIdAtChange` ≠ текущая должность).
 * Собирать `ActorRights` руками в коде приложения нельзя: правило снимка тогда
 * придётся повторить, и одна из копий его потеряет.
 *
 * ⚠️ В волне В-О1а функции этого файла НЕ ЗОВЁТ НИКТО, кроме их тестов: поведение ни одного
 * из восьми мест решения не меняется. Потребители приходят волнами В-О2 и далее.
 *
 * ─── Почему файл не в `enums.ts` ────────────────────────────────────────────
 *
 * Зеркала двух enum лежат рядом с правилом, которое их читает: таблица пар,
 * признак «руководителю добавляется» и функция расходятся с составом enum
 * одной правкой, и эта правка должна быть видна в одном диффе.
 */
import { AccessLevel } from './enums';

// ─── Зеркала Prisma-enum ─────────────────────────────────────────────────────
//
// ⚠️ Оба зеркала ОБЯЗАТЕЛЬНЫ и сверяются со схемой в обе стороны — правило R7
// гейта `infra/scripts/check-registration-sets.mjs`, реестр
// `REQUIRED_ENUM_MIRRORS`. Довод по каждому значению — в `schema.prisma`, у
// самого enum; здесь он не пересказывается.

/** Восемь изменяемых прав. Номера в комментариях — по списку Р-188. */
export const UserRight = {
  /** № 2 */
  PROJECT_ARCHIVE: 'PROJECT_ARCHIVE',
  /** № 3 */
  CONTRACT_SUM_READ: 'CONTRACT_SUM_READ',
  /** № 4 */
  CONTRACT_WRITE: 'CONTRACT_WRITE',
  /** № 5 */
  EXPENSE_READ: 'EXPENSE_READ',
  /** № 6 */
  EXPENSE_WRITE: 'EXPENSE_WRITE',
  /** № 7 */
  WORKLOAD_ALL_READ: 'WORKLOAD_ALL_READ',
  /** № 8 */
  DASHBOARD_ORG_READ: 'DASHBOARD_ORG_READ',
  /** № 9 */
  AUDIT_READ: 'AUDIT_READ',
} as const;
export type UserRight = (typeof UserRight)[keyof typeof UserRight];

/** Три состояния строки прав. `INHERIT` — «сброшено»: строка есть, эффекта нет. */
export const RightEffect = {
  ALLOW: 'ALLOW',
  DENY: 'DENY',
  INHERIT: 'INHERIT',
} as const;
export type RightEffect = (typeof RightEffect)[keyof typeof RightEffect];

/** Все права — в порядке списка Р-188. Для экранов и исчерпывающих проверок. */
export const USER_RIGHTS: readonly UserRight[] = Object.values(UserRight);

// ─── Таблицы правила ─────────────────────────────────────────────────────────

/**
 * Право «вести» → парное «видеть», без которого оно не действует (Р-195).
 *
 * ⚠️ Для договоров «видеть» — это «видеть СУММУ договора», а не «читать
 * справочник договоров»: справочник руководитель отдела читает по должности.
 *
 * Пар ровно две; у остальных шести прав парного нет.
 */
export const RIGHT_REQUIRES_VIEW: Readonly<Partial<Record<UserRight, UserRight>>> = {
  [UserRight.CONTRACT_WRITE]: UserRight.CONTRACT_SUM_READ,
  [UserRight.EXPENSE_WRITE]: UserRight.EXPENSE_READ,
};

/**
 * Добавляется ли право руководителю отдела (`ALLOW`).
 *
 * `Record`, а не список исключений: новое значение `UserRight` без строки здесь
 * — ошибка сборки, а не молчаливое «да».
 *
 * `CONTRACT_WRITE` — нет: оно есть только у администраторов, по должности
 * (Р-217 б, ⚠️ решение оркестратора). Справочник договоров общий на бюро и к
 * «где вошёл» не привязывается.
 *
 * `PROJECT_ARCHIVE` — нет: решение владельца 10.10.2026 (Ф8 · В-А, фикс-пак 1).
 * Руководитель отдела входит в объект сам, и галочка «архивировать» давала бы
 * ему архивацию любого живого объекта бюро. Право есть только у
 * администраторов, по должности.
 */
export const RIGHT_GRANTABLE_TO_MANAGER: Readonly<Record<UserRight, boolean>> = {
  [UserRight.PROJECT_ARCHIVE]: false,
  [UserRight.CONTRACT_SUM_READ]: true,
  [UserRight.CONTRACT_WRITE]: false,
  [UserRight.EXPENSE_READ]: true,
  [UserRight.EXPENSE_WRITE]: true,
  [UserRight.WORKLOAD_ALL_READ]: true,
  [UserRight.DASHBOARD_ORG_READ]: true,
  [UserRight.AUDIT_READ]: true,
};

/**
 * МЕХАНИЗМ: действует ли строка с таким эффектом на человека этого уровня
 * (решение плана П2, **Р-217 б**): `DENY` — только на администратора, `ALLOW` —
 * только на руководителя отдела и только по добавляемому праву. Строка «не
 * того» уровня инертна — так её читает и ступень 1 (`resolveRightState`).
 *
 * ⚠️ Это НЕ ответ «можно ли такую строку поставить» — на него отвечает
 * `isEffectApplicable`, и с 11.10.2026 ответы расходятся: `DENY` на
 * администратора ДЕЙСТВУЕТ (если строка лежит), но ПОСТАВИТЬ его нельзя.
 * Читает эту функцию описание карточки («действует ли лежащая строка»).
 */
export function effectActsOnLevel(
  effect: Exclude<RightEffect, 'INHERIT'>,
  level: AccessLevel,
  right: UserRight,
): boolean {
  if (effect === RightEffect.DENY) return level === AccessLevel.ADMIN;
  return level === AccessLevel.MANAGER && RIGHT_GRANTABLE_TO_MANAGER[right];
}

/**
 * ВХОД: можно ли ПОСТАВИТЬ человеку этого уровня такой эффект.
 *
 *   · `DENY` — НИКОМУ И НИКОГДА (решение владельца 11.10.2026, Ф8 · В-У:
 *     положенное по должности не отнимается). Уровень и право в ответе не
 *     участвуют — параметры оставлены, чтобы правило читалось одним вызовом;
 *   · `ALLOW` — только руководителю отдела и только по добавляемому праву
 *     (решение плана П2, **Р-217 б**) — то же, что отвечает механизм;
 *   · для `INHERIT` вопрос не ставится — сброс применим всегда, в том числе к
 *     строке `DENY`, лежащей с прежних времён.
 *
 * Одно правило на два места (Ф8 · В-Э, фикс-пак 1): сервер по нему ОТКАЗЫВАЕТ
 * в записи (422), экран по нему НЕ ПРЕДЛАГАЕТ действие. Пока правило жило
 * копией в вебе, расхождение дало бы кнопку, на которую сервер всегда отвечает
 * отказом, — либо отсутствие кнопки там, где запись прошла бы.
 */
export function isEffectApplicable(
  effect: Exclude<RightEffect, 'INHERIT'>,
  level: AccessLevel,
  right: UserRight,
): boolean {
  if (effect === RightEffect.DENY) return false;
  return effectActsOnLevel(effect, level, right);
}

/**
 * Какое «видеть» надо добавить ПРЕЖДЕ, чем добавлять это право (**Р-195**);
 * `null` — препятствия нет.
 *
 * Вторая половина вопроса «можно ли добавить»: `isEffectApplicable` отвечает по
 * должности и праву, эта — по тому, что у человека уже стоит. «Вести» без
 * действующего парного «видеть» ступень 1 всё равно не откроет
 * (`resolveRightState`, уровень MANAGER, шаг 2), так что строка легла бы
 * мёртвой: галочка есть, права нет.
 *
 * Одно правило на два места, как и `isEffectApplicable` (шлифовка 1, находка QA
 * на стенде): сервер по нему ОТКАЗЫВАЕТ в записи (422), экран по нему НЕ
 * ПРЕДЛАГАЕТ действие. Пока оно жило только в вебе, сервер принимал запрос,
 * которого экран не шлёт.
 *
 * ⚠️ Только В ЭТУ сторону. Убрать «видеть» при стоящем «вести» можно: «вести»
 * остаётся недействующим и так и показано. Запрета на обратное здесь нет
 * намеренно — сброс принимается всегда (решение плана П4).
 *
 * Для непарного права, для неприменимого `ALLOW` (не руководитель; «вести
 * договоры» и «архивировать» руководителю не выдаются вовсе) — `null`: там
 * отказывает либо не отказывает `isEffectApplicable`, не это правило.
 *
 * @param hasEffectiveAllow добавлено ли и ДЕЙСТВУЕТ ли у человека право: строка
 *   `ALLOW`, чей снимок должности равен текущей. «Видеть», оставшееся от
 *   прежней должности, не считается.
 */
export function viewRequiredBeforeAllow(
  level: AccessLevel,
  right: UserRight,
  hasEffectiveAllow: (view: UserRight) => boolean,
): UserRight | null {
  if (!isEffectApplicable(RightEffect.ALLOW, level, right)) return null;
  const view = RIGHT_REQUIRES_VIEW[right];
  if (view === undefined || hasEffectiveAllow(view)) return null;
  return view;
}

/** Где действует ДОБАВЛЕННОЕ право: на объекте, куда актор вошёл, либо везде. */
export const RightGrantScope = {
  /** «Да» только там, где у актора есть строка руководителя отдела объекта. */
  OBJECT: 'OBJECT',
  /** «Да» без оглядки на объект: бюро целиком. */
  ORG: 'ORG',
} as const;
export type RightGrantScope = (typeof RightGrantScope)[keyof typeof RightGrantScope];

/**
 * Область добавленного права (Р-204).
 *
 * Чьё слово за чем стоит — различается, и это не формальность:
 *   · № 5, № 6 — `OBJECT` по тексту Р-204, граница 3 («в пределах области»);
 *   · № 2 — руководителю не добавляется вовсе (решение владельца 10.10.2026),
 *     `GRANTED` по нему ступень 1 не возвращает. `OBJECT` оставлен закрытым
 *     умолчанием — как у № 4;
 *   · № 3 — `OBJECT` по Р-217 (а): договоры объектов, куда вошёл (⚠️ решение
 *     оркестратора, не владельца);
 *   · № 7, № 8, № 9 — `ORG`: ⚠️ толкование оркестратора к Р-204, владельцу не
 *     задавалось;
 *   · № 4 — руководителю не добавляется вовсе, `GRANTED` по нему ступень 1 не
 *     возвращает. Стоит `OBJECT` как закрытое умолчание: окажись оно когда-нибудь
 *     добавляемым, без предиката места оно не откроется.
 *
 * `Record`, а не список: новое право без строки здесь — ошибка сборки.
 */
export const RIGHT_GRANT_SCOPE: Readonly<Record<UserRight, RightGrantScope>> = {
  [UserRight.PROJECT_ARCHIVE]: RightGrantScope.OBJECT,
  [UserRight.CONTRACT_SUM_READ]: RightGrantScope.OBJECT,
  [UserRight.CONTRACT_WRITE]: RightGrantScope.OBJECT,
  [UserRight.EXPENSE_READ]: RightGrantScope.OBJECT,
  [UserRight.EXPENSE_WRITE]: RightGrantScope.OBJECT,
  [UserRight.WORKLOAD_ALL_READ]: RightGrantScope.ORG,
  [UserRight.DASHBOARD_ORG_READ]: RightGrantScope.ORG,
  [UserRight.AUDIT_READ]: RightGrantScope.ORG,
};

// ─── Ступень 1 ───────────────────────────────────────────────────────────────

/** Ответ ступени 1 — откуда право. Разбор значений — в шапке файла. */
export const RightState = {
  DENIED: 'DENIED',
  GRANTED: 'GRANTED',
  ROLE: 'ROLE',
} as const;
export type RightState = (typeof RightState)[keyof typeof RightState];

/**
 * Права актора — вход ступени 1. Собирается `collectActorRights` из строк
 * таблицы; руками в коде приложения не собирается (разбор — в шапке файла).
 *
 * `own` принимает и `INHERIT`: он читается как «строки нет». Сборка кладёт сюда
 * состояния уже без `INHERIT`, но правило ступени 1 не должно зависеть от
 * того, отфильтровал ли кто-то сброшенные строки, — сброшенная строка физически
 * остаётся в таблице, и забытый фильтр иначе превратил бы «сброшено» в
 * действующий эффект.
 */
export interface ActorRights {
  /** Собственные состояния актора: право → эффект его строки. */
  readonly own: Readonly<Partial<Record<UserRight, RightEffect>>>;
  /** Права, отнятые у ГИПа, чьим помощником актор является; иначе пусто. */
  readonly deniedByGip: readonly UserRight[];
}

/** Права актора, у которого нет ни одной строки и нет ГИПа с запретами. */
export const NO_RIGHT_OVERRIDES: ActorRights = Object.freeze({
  own: Object.freeze({}),
  deniedByGip: Object.freeze([]),
});

/** Отнято ли право у администратора — своим запретом либо запретом его ГИПа. */
function isDeniedForAdmin(rights: ActorRights, right: UserRight): boolean {
  return rights.own[right] === RightEffect.DENY || rights.deniedByGip.includes(right);
}

/**
 * Ступень 1: откуда у актора право.
 *
 * ⚠️ ПЕРВАЯ РАЗВИЛКА — УРОВЕНЬ, а не эффект (решение плана фазы П2). Строка с
 * эффектом «не того» уровня ИНЕРТНА: `DENY` действует только на администратора,
 * `ALLOW` — только на руководителя отдела. Если проверять `DENY` до уровня,
 * запрет, переживший смену должности мимо сброса (откат, посев, гонка),
 * отнимает у руководителя отдела его собственный отдел, а снять его нечем.
 *
 * Уровень ADMIN (по должности право есть; закрыть его может только строка
 * `DENY` — ⚠️ с 11.10.2026 штатно её поставить нечем, ветки ниже работают
 * лишь для строки, лежащей с прежних времён либо записанной мимо сервиса):
 *   1. право «вести», а парное «видеть» отнято       → DENIED (Р-195);
 *   2. собственный `DENY`                             → DENIED (Р-197);
 *   3. право отнято у ГИПа, чьим помощником он служит → DENIED (Р-197);
 *   4. иначе                                          → ROLE   (`ALLOW` инертен).
 *
 * Уровень MANAGER (по должности права нет — его можно только добавить):
 *   1. нет собственного `ALLOW` либо право не добавляемо → ROLE (`DENY`
 *      инертен; `ALLOW` на `CONTRACT_WRITE` — тоже, Р-217 б);
 *   2. право «вести», а на парное «видеть» `ALLOW` нет   → ROLE (Р-195);
 *   3. иначе                                              → GRANTED.
 *
 * Прочие уровни (EMPLOYEE, SUPERVISOR)                → ROLE   (Р-191: строки
 *   не учитываются вовсе).
 *
 * ⚠️ Р-195 у руководителя проверяется ДВАЖДЫ, и вторая проверка первой не
 * заменяется. Здесь — «есть ли „видеть“ вообще»: по должности руководитель
 * расходов не видит нигде, значит без `ALLOW` «видеть» вести ему нечего, и
 * объект для этого знать не нужно (фикс-пак 1, замечание ревью). На ступени 2
 * — «отвечает ли „видеть“ „да“ НА ЭТОМ ЖЕ ОБЪЕКТЕ»: оба права объектные.
 *
 * ⚠️ Ответ читается через `matchRightState`, а не сравнением — договор чтения
 * в шапке файла.
 *
 * Чистая функция: ни базы, ни часов, ни настроек.
 */
export function resolveRightState(
  rights: ActorRights,
  level: AccessLevel,
  right: UserRight,
): RightState {
  if (level === AccessLevel.ADMIN) {
    const view = RIGHT_REQUIRES_VIEW[right];
    if (view !== undefined && isDeniedForAdmin(rights, view)) return RightState.DENIED;
    if (isDeniedForAdmin(rights, right)) return RightState.DENIED;
    return RightState.ROLE;
  }

  if (level === AccessLevel.MANAGER) {
    if (rights.own[right] !== RightEffect.ALLOW || !RIGHT_GRANTABLE_TO_MANAGER[right]) {
      return RightState.ROLE;
    }
    const view = RIGHT_REQUIRES_VIEW[right];
    if (view !== undefined && rights.own[view] !== RightEffect.ALLOW) return RightState.ROLE;
    return RightState.GRANTED;
  }

  return RightState.ROLE;
}

// ─── Разбор состояния ────────────────────────────────────────────────────────

/** Ветки разбора состояния. Все три обязательны — пропущенная не соберётся. */
export interface RightStateBranches<T> {
  /** Отнято: «нет» везде, и на своём объекте (Р-197). */
  readonly denied: () => T;
  /**
   * Добавлено сверх должности. `scope` — из `RIGHT_GRANT_SCOPE`:
   * `ORG` — «да»; `OBJECT` — «да», только если предикат места (ступень 2)
   * подтвердил, что актор вошёл в объект. Вернуть «да» на `OBJECT`, не спросив
   * место, — открыть право на чужих объектах.
   */
  readonly granted: (scope: RightGrantScope) => T;
  /**
   * Поправок нет либо они инертны: отвечает ДЕЙСТВУЮЩЕЕ правило должности — то
   * самое выражение, что стояло в этом месте до Ф8. Не «да» и не «нет».
   */
  readonly role: () => T;
}

/**
 * Разобрать состояние ступени 1 — единственный рекомендованный способ его
 * читать (договор чтения — в шапке файла).
 *
 *     matchRightState(resolveRightState(actor.rights, level, right), right, {
 *       denied: () => false,
 *       granted: (scope) => scope === RightGrantScope.ORG || isProjectRo(...),
 *       role: () => действующийПредикат(...),
 *     });
 */
export function matchRightState<T>(
  state: RightState,
  right: UserRight,
  branches: RightStateBranches<T>,
): T {
  switch (state) {
    case RightState.DENIED:
      return branches.denied();
    case RightState.GRANTED:
      return branches.granted(RIGHT_GRANT_SCOPE[right]);
    case RightState.ROLE:
      return branches.role();
    default: {
      // Четвёртое состояние без ветки — ошибка сборки, а не молчаливое «да».
      const unreachable: never = state;
      throw new Error(`Неизвестное состояние права: ${String(unreachable)}`);
    }
  }
}

// ─── Сборка входа из строк таблицы ───────────────────────────────────────────

/** Строка `UserRightOverride` — ровно те поля, что читает сборка. */
export interface RightOverrideRow {
  readonly right: UserRight;
  readonly effect: RightEffect;
  /** Должность (`Role.id`) владельца строки на момент её последнего изменения. */
  readonly roleIdAtChange: number;
}

/** Человек и его строки прав: текущая должность плюс ВСЕ его строки, как есть. */
export interface RightRowsOwner {
  /** ТЕКУЩАЯ должность (`User.roleId`), прочитанная тем же запросом, что строки. */
  readonly roleId: number;
  readonly rows: readonly RightOverrideRow[];
}

/** Действует ли строка: снимок должности равен текущей и строка не сброшена. */
function isLiveRow(row: RightOverrideRow, currentRoleId: number): boolean {
  return row.roleIdAtChange === currentRoleId && row.effect !== RightEffect.INHERIT;
}

/**
 * Собрать вход ступени 1 из строк таблицы.
 *
 * ─── Правило снимка должности (Р-198, страховка) ────────────────────────────
 *
 * Р-198: смена должности сбрасывает всё выданное и отнятое. Сброс делает
 * сервис (В-О1б) — но есть пути мимо него: прежняя версия кода после отката на
 * проде меняет должность и о таблице не знает; посев; прямая запись. На таком
 * пути строка остаётся с действующим эффектом у человека УЖЕ В ДРУГОЙ должности.
 *
 * Поэтому строка несёт снимок — `roleIdAtChange`, должность владельца на момент
 * последнего изменения строки, — и строка, чей снимок НЕ РАВЕН текущей
 * должности владельца, ИНЕРТНА: читается как `INHERIT`. Сравнивается ДОЛЖНОСТЬ,
 * а не уровень: Р-198 говорит о смене должности, и перевод «ГИП → техдиректор»
 * (оба администраторы) сбрасывает так же.
 *
 * ⚠️ Направление: инертный `DENY` ВОЗВРАЩАЕТ администратору право. Это и есть
 * Р-198 («сбрасывается и отнятое»), а не побочный эффект.
 *
 * ─── Договор сборки — что обязан сделать вызывающий ─────────────────────────
 *
 *   · `actor.roleId` и `actor.rows` читаются ОДНИМ снимком базы (одним запросом
 *     либо в одной транзакции): должность, прочитанная раньше строк, сравнится
 *     со снимком строк, записанных уже после смены;
 *   · `actor.rows` — ВСЕ строки человека, без предварительного отбора: отбор
 *     (снимок, `INHERIT`) делается здесь и только здесь;
 *   · `gip` — `null`, если актор НЕ помощник ГИПа (`assistantOfUserId` пуст).
 *     Ключ обязателен намеренно: забыть ГИПа — значит молча не унаследовать
 *     запрет (Р-197);
 *   · `gip.roleId` — ТЕКУЩАЯ должность ГИПа, `gip.rows` — все ЕГО строки. Запрет
 *     наследуется только из строк, чей снимок равен текущей должности ГИПа:
 *     запрет, залипший у бывшего ГИПа мимо сброса, помощнику не передаётся;
 *   · наследуется только `DENY` (Р-197: «не „выданное ГИПу наследуется“»).
 *
 * Чего сборка НЕ проверяет: уровень. «`DENY` действует только на администратора,
 * `ALLOW` — только на руководителя» — правило ступени 1 (`resolveRightState`),
 * и там оно первой развилкой. Здесь строка «не того» уровня в `own` попадает.
 *
 * Чистая функция; вход не изменяет.
 */
export function collectActorRights(input: {
  readonly actor: RightRowsOwner;
  readonly gip: RightRowsOwner | null;
}): ActorRights {
  const own: Partial<Record<UserRight, RightEffect>> = {};
  for (const row of input.actor.rows) {
    if (isLiveRow(row, input.actor.roleId)) own[row.right] = row.effect;
  }

  const gip = input.gip;
  const denied = new Set<UserRight>();
  if (gip !== null) {
    for (const row of gip.rows) {
      if (isLiveRow(row, gip.roleId) && row.effect === RightEffect.DENY) denied.add(row.right);
    }
  }

  // Порядок — по списку прав, а не по порядку строк: ответ не должен зависеть
  // от того, как база отсортировала выборку.
  return { own, deniedByGip: USER_RIGHTS.filter((right) => denied.has(right)) };
}
